import { Component } from '@theme/component';
import { sectionRenderer } from '@theme/section-renderer';
import { RecentlyViewed } from '@theme/recently-viewed-products';

/**
 * Clears theme client caches and reloads the page with a cache-bust query param.
 * @extends {Component}
 */
class CachePurgeComponent extends Component {
  async purgeCache() {
    const button = this.refs.button;
    const statusMessage = this.refs.statusMessage;

    if (button instanceof HTMLButtonElement) {
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
    }

    if (statusMessage instanceof HTMLElement) {
      statusMessage.textContent = this.dataset.purgingMessage || 'Clearing cache…';
      statusMessage.classList.remove('visually-hidden');
    }

    sectionRenderer.clearCache();
    RecentlyViewed.clearProducts();

    for (const key of Object.keys(sessionStorage)) {
      if (key.startsWith('product-grid-view-') || key === 'custom-transition-type') {
        sessionStorage.removeItem(key);
      }
    }

    if ('caches' in window) {
      try {
        const names = await caches.keys();
        await Promise.all(names.map((name) => caches.delete(name)));
      } catch {
        /* ignore Cache API errors */
      }
    }

    const url = new URL(window.location.href);
    url.searchParams.set('_cache_purge', String(Date.now()));
    window.location.replace(url.toString());
  }
}

if (!customElements.get('cache-purge-component')) {
  customElements.define('cache-purge-component', CachePurgeComponent);
}
